// User
export const RESET_VALUES = 'RESET_VALUES';

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';



// WEBPACK FOOTER //
// ./src/actions/user-actions.js